import { Box, Heading } from '@applyboard/crystal-ui';

export function RolesAndAccessHeading(): JSX.Element {
  return (
    <Box>
      <Heading level={2}>User Type & Access</Heading>
    </Box>
  );
}
